import { useMemo, useState } from "react";
import { films, filmCategories } from "@/mocks/films";

export default function FilmGallery() {
  const [active, setActive] = useState("all");

  const visibleFilms = useMemo(
    () => (active === "all" ? films : films.filter((film) => film.category === active)),
    [active]
  );

  return (
    <section id="films" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-3xl">
            <span className="text-sm font-medium text-primary-600 tracking-widest uppercase">
              Film List
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              精选片单：值得一看的代表作
            </h2>
            <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              下面按题材方向整理了九部具有代表性的作品，涵盖翻拍经典、宫廷史诗与作者电影。
              点击上方的筛选标签，即可按你感兴趣的方向挑选。
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {filmCategories.map((category) => (
            <button
              key={category.id}
              type="button"
              onClick={() => setActive(category.id)}
              aria-pressed={active === category.id}
              className={`px-4 py-2 rounded-full text-sm cursor-pointer transition-colors border whitespace-nowrap ${
                active === category.id
                  ? "bg-primary-500 border-primary-500 text-background-50"
                  : "bg-background-100 border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {category.label}
            </button>
          ))}
          <span className="ml-auto self-center text-sm text-foreground-600">
            共 {visibleFilms.length} 部
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {visibleFilms.map((film) => (
            <article
              key={film.id}
              className="group rounded-lg overflow-hidden bg-background-100 border border-background-200 flex flex-col"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={film.cover}
                  alt={`《${film.title}》影片海报`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-foreground-950/60 text-background-50 text-xs backdrop-blur-sm">
                  {film.year}
                </span>
                <span className="absolute top-3 right-3 px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs">
                  {film.categoryLabel}
                </span>
              </div>

              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                  {film.title}
                </h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-600">
                  导演：{film.director} · 主演：{film.cast}
                </p>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">
                  {film.summary}
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {film.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}